import { Grid, Paper, Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";

//Components
import Autocomplete from "../../inputs/Autocomplete";
import Dropdown from "../../inputs/dropdown";
import Searchbox from "../../inputs/searchbox";
import AutocompleteChannels from '../../inputs/autocompletes/autocompleteChannels';
import AutocompleteSubChannels from '../../inputs/autocompletes/autocompleteSubChannels';
import AutocompleteBolean from '../../inputs/autocompletes/autocompleteBolean';

import WrapperDatePicker from '../../wrapperDatapicker'

import { InvoicePaymentMethodsSelect } from "../../../models/EnumEntity";

// Hooks
import useUser from '../../../hooks/user/useUser';
import useStyles from '../styles';
import FilterListIcon from "@mui/icons-material/FilterList";

const InvoiceFilters = ({ filters, setFilters, valuesTypeSelect, clearFilters, isInvoice = false }) => {
    const { branch: { pvs }, business } = useUser();
    const { classes } = useStyles();
    const [paymentMethodsSelected, setPaymentMethodsSelected] = useState([])

    useEffect(() => {
        if (filters?.paymentMethods) {
            if (Array.isArray(filters.paymentMethods))
                setPaymentMethodsSelected(InvoicePaymentMethodsSelect.filter(e => filters.paymentMethods.some(code => code === e.value)));
            else
                setPaymentMethodsSelected([InvoicePaymentMethodsSelect.find(s => s.value === filters.paymentMethods)]);
        } else setPaymentMethodsSelected([]);
    }, [filters?.paymentMethods])

    const handleFilterChange = (event) => {
        setFilters({
            ...filters,
            pageNumber: 1,
            [event.target.name]: event.target.value
        });
    }

    const handleFilterChannelChange = (event, option, name) => {
        setFilters({
            ...filters,
            pageNumber: 1,
            [name]: option?.value,
            subChannel: null
        });
    }

    const handleAutoCompleteChange = (event, option, name) => {
        setFilters({
            ...filters,
            pageNumber: 1,
            [name]: option?.value
        });
    }

    const handleAutocompleteChange = (event, options) => {
        setPaymentMethodsSelected(options);
        setFilters({
            ...filters,
            pageNumber: 1,
            paymentMethods: options.map(s => s.value)
        });
    }

    return (
        <Paper className={classes.paper}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        md: 8
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid
                            size={{
                                xs: 12,
                                md: 12
                            }}
                        >
                            <Typography variant='inherit' color='primary'>
                                Filtrar por factura:
                            </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 5,
                                md: 4
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='type'
                                onChange={handleFilterChange}
                                size='small'
                                label="Tipo de factura"
                                getOptionLabel={(option) => option?.label}
                                getOptionValue={(option) => option?.value}
                                value={filters?.type || ''}
                                values={valuesTypeSelect}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 3,
                                md: 4
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='billingCode'
                                label='Punto de venta'
                                onChange={handleFilterChange}
                                size='small'
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.billingCode}
                                value={filters?.billingCode || ''}
                                values={pvs}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 4
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='number'
                                label='Nro de factura'
                                onChange={handleFilterChange}
                                value={filters?.number || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por medios de pago: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                md: 12
                            }}
                        >
                            <Autocomplete
                                fullWidth
                                multiple
                                size='small'
                                options={InvoicePaymentMethodsSelect}
                                getOptionLabel={(option) => option?.label || ''}
                                getOptionValue={(option) => option?.value}
                                renderOption={(props, option) => <span {...props}>{option.label}</span>}
                                onChange={handleAutocompleteChange}
                                value={paymentMethodsSelected}
                                TextProps={{
                                    label: 'Medios de pago',
                                    name: 'paymentMethods'
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.from}
                                handleFilterChange={handleFilterChange}
                                type="from"
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.to}
                                handleFilterChange={handleFilterChange}
                                type="to"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por cliente: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='customerName'
                                label='Nombre'
                                onChange={handleFilterChange}
                                value={filters?.customerName || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='customerDocNum'
                                label='Documento'
                                onChange={handleFilterChange}
                                value={filters?.customerDocNum || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 8
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por vendedor: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 4
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='sellerCode'
                                label='Código'
                                onChange={handleFilterChange}
                                value={filters?.sellerCode || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 8
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='sellerName'
                                label='Nombre'
                                onChange={handleFilterChange}
                                value={filters?.sellerName || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por cupones: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 12
                            }}
                        >
                            <Searchbox
                                fullWidth
                                size='small'
                                name='cupon'
                                label='N° Cupón'
                                onChange={handleFilterChange}
                                value={filters?.cuponNumber || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Filtrar por canal: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >
                            <AutocompleteChannels
                                fullWidth
                                size="small"
                                name='channel'
                                isFranchise={business.isFranchise}
                                onChange={handleFilterChannelChange}
                                value={filters?.channel || ""}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >
                            <AutocompleteSubChannels
                                fullWidth
                                size="small"
                                onChange={handleAutoCompleteChange}
                                value={filters?.subChannel || ""}
                                channel={business.isFranchise ? 'Tienda' : filters?.channel}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {isInvoice &&
                    <Grid
                        size={{
                            xs: 12,
                            sm: 3
                        }}
                    >
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <Typography variant='inherit' color='primary'>Inicializadas en la App: </Typography>
                            </Grid>
                            <Grid size={12}>
                                <AutocompleteBolean
                                    name="isFromApp"
                                    onChange={handleAutoCompleteChange}
                                    size="small"
                                    label="Inicializadas en la App"
                                    value={filters?.isFromApp?.toString() || ""}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid className={classes.rootFab} size="grow">
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        className={classes.button}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}
export default InvoiceFilters;
